module.exports = __webpack_public_path__ + "img/05.054016d3.jpg";